<template>
  <Fragment>
    <tr class="transparent-hover">
      <td rowspan="2" colspan="1" :class="`px-1 pl-3 ${borderClass}`">
        <v-checkbox v-model="produto.$$active"
                    dense
                    color="primary"/>
      </td>
      <td rowspan="2" colspan="3" :class="`px-1 pr-3 ${borderClass}`">
        <px-produto-descricao :especificacao="produto.$$especificacaoProdutoOrigem"
                              :produto="produto.produto"/>
        <px-show-is-homologado small
                               :produto="produto.produto"
                               :id-fornecedor="idFornecedor"/>
      </td>
      <td class="px-1 d-flex no-border-fixed-height" colspan="1">
        <px-input-currency dense
                           label="Preço unitário"
                           class="required rounded-tag-small mt-3"
                           :disabled="!produto.$$active"
                           :options="configuracaoMoeda"
                           :precision="produto.produto.casasDecimais"
                           :error="$v.produto.$$precoUnitario.$error"
                           @blur="$v.produto.$$precoUnitario.$touch()"
                           v-model="produto.$$precoUnitario"/>
        <px-input-percentual dense
                             label="ICMS"
                             show-suffix
                             input-class="rounded-tag-small mt-3 ml-1 mr-1 width-percent"
                             :disabled="!produto.$$active"
                             v-model="produto.$$icms"/>
        <px-input-percentual dense
                             label="IPI"
                             show-suffix
                             input-class="rounded-tag-small mt-3 width-percent"
                             :disabled="!produto.$$active"
                             v-model="produto.$$ipi"/>
      </td>
      <td class="px-1 no-border-fixed-height" colspan="1">
        <px-anexo :max="3"
                  :disabled="!produto.$$active"
                  @loading="onFileLoad"
                  v-model="produto.$$arquivosProduto"/>
      </td>
    </tr>
    <tr class="transparent-hover">
      <td class="px-1" colspan="2">
        <v-textarea label="Especificação fornecedor"
                    class="mb-2 mr-1 rounded-tag-small"
                    rows="1"
                    dense
                    outlined
                    hide-details
                    auto-grow
                    :disabled="!produto.$$active"
                    v-model="produto.$$especificacaoProduto" />
      </td>
    </tr>
  </Fragment>
</template>
<script>
import Vue from 'vue';
import { Fragment } from 'vue-frag';
import { required } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';
import moedaMixin from '@/mixins/moeda-mixin';

export default {
  mixins: [validationMixin, moedaMixin],
  props: {
    produto: {
      type: Object,
      required: true,
    },
    moeda: String,
    showDivider: Boolean,
    idFornecedor: [Number, String],
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    checkCodigo() {
      return item => item.codigo;
    },
    labelCodigo() {
      return item => `${item.codigo} -`;
    },
    labelDescricao() {
      return produto => Vue.filter('truncate')(produto.produto.descricao, 60);
    },
    borderClass() {
      return this.showDivider ? '' : 'no-border';
    },
  },
  methods: {
    onFileLoad(loading) {
      this.produto.$$hasFileLoading = loading;
    },
  },
  validations: {
    produto: {
      $$precoUnitario: {
        required,
        minValue(value, model) {
          if (!model.$$active) {
            return true;
          }
          return value > 0;
        },
      },
    },
  },
  components: {
    Fragment,
  },
};
</script>
<style scoped>
.no-border {
  border-bottom: none !important;
}

.no-border-fixed-height {
  border-bottom: none !important;
  height: 60px;
}

.width-percent {
  max-width: 12%;
}
</style>
